/* ------------------------------------------ gfDraggable 20/05/2017 ----------------------------------------- */

import HELPER from '@/app/utils/HELPER';
import atom from '@/app/editor/iframe/atom';
import throttle from '../../utils/throttle';
import { checkKeyValid } from '@/app/utils/checkRoleApply';
import { app } from '@/store';
/**
 * Draggable
 */
(function (jQuery) {
  /**
   * gfDraggable
   * @param element ..
   * @param options ..
   */
  (jQuery as any).gfDraggable = function (element: Element, options: object) {
    const defaults = {
      targetElement: undefined,
      type: 'default',
      /**
       * start
       */
      start: function () {},
      /**
       * drag
       */
      drag: function () {},
      /**
       * stop
       */
      stop: function () {},
    };
    this.settings = {};

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;

    const $element = jQuery(element);

    let $targetElement: JQuery;
    let $stElement: JQuery;
    let $from: JQuery;
    let $to: JQuery;
    let $helper: JQuery;
    let $dragHidden: JQuery;
    const optimizeInitDragHidden = checkKeyValid('optimizeInitDragHidden');
    let isInitDragHidden = false;

    // nearY is global in gfDraggable
    let nearY:
      | {
          id: number;
          top: number;
          left: number;
          width: number;
        }
      | undefined;

    let $backupElmShowTool: JQuery;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');
    const $gfResTool = jQuery('#gfResTool');

    /* Iframe */
    let $gfFrame = jQuery('#gfFrame');
    let $gfVisualFrame = jQuery('#gfVisualFrame');
    let $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    let $gryffBody = $gfFrame.contents().find('body').first();

    /**
     * init
     */
    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $targetElement = this.settings.targetElement;
      // disable click
      $element.off('click').on('click', function () {
        return false;
      });

      $element.off('mousedown.drag').on('mousedown.drag', function (eOne: JQueryEventObject) {
        /* Editor */
        const iframeInited = app.$store.state.page.loadingContentEditor;
        if (iframeInited) {
          return;
        }

        const $gfLeftSideBar = jQuery('#gfLeftSideBar');
        const $gfResTool = jQuery('#gfResTool');

        /* Iframe */
        $gfFrame = jQuery('#gfFrame');
        $gfVisualFrame = jQuery('#gfVisualFrame');
        $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
        $gryffBody = $gfFrame.contents().find('body').first();
        eOne.preventDefault();
        window._counter = 0;
        const $body = jQuery('body');

        if (eOne.which != 3) {
          // close context menu
          if ($gryffBody.data('gfcontextmenu') != undefined && window._isContextOpenned) {
            $gryffBody.data('gfcontextmenu').closeMenu();
          }

          /// START DRAGGING =========================================
          _this.settings.start();

          // History
          if ($targetElement != undefined) {
            const $currentTargetElement = $targetElement;
            let $itemContent;
            let position = {};
            if ($gryffEditor.data('gfhistory')) {
              position = $gryffEditor.data('gfhistory').getPosition($itemContent, $currentTargetElement);
            }

            const history = {
              id: $currentTargetElement.attr('id'),
              action: 'move',
              events: [
                {
                  action: 'cut',
                  position: position,
                },
              ],
            };
            $gryffEditor.trigger('history', history);
          }

          const startX = eOne.pageX;
          const startY = eOne.pageY;
          const iframeOffset = $gfFrame.offset();
          let fL = 0;
          let fT = 0;
          if (iframeOffset) {
            fL = iframeOffset.left;
            fT = iframeOffset.top;
          }

          if ($targetElement == undefined) {
            _this.initHelper(startX, startY, 0, 0, 0, 1);
          } else {
            _this.initHelper(startX, startY, fL, fT, 0, window._zoomOut);
            $from = $targetElement.closest('.item-content');
          }

          if (!optimizeInitDragHidden) {
            _this.initDragHidden();
          }
          _this.showVisualFrame();

          if (window._placeHolders && window._placeHolders.length > 0) {
            nearY = window._placeHolders[0];
          }

          if ($targetElement == undefined) {
            $gryffEditor.data('gryffeditor').setDragging(true);
          }

          $gfLeftSideBar.off('mousemove.dragL').on('mousemove.dragL', function (eTwo) {
            if ($gryffEditor.data('gryffeditor')?.isDragging()) {
              let pageX = eTwo.pageX;
              let pageY = eTwo.pageY;

              const fST = $gfFrame.contents().scrollTop();
              _this.updateHelper(pageX, pageY, 0, 0, fST, 1);

              // find nearrest Y
              const $dragHidden = $gryffEditor.find('.drag-hidden.show');
              if ($dragHidden.length > 0) {
                const offsetDrag = $dragHidden.offset();
                if (offsetDrag) {
                  const width = $dragHidden.width() || 0;
                  const height = $dragHidden.height() || 0;
                  pageX = offsetDrag.left + width / 2;
                  pageY = offsetDrag.top + height / 2;
                }
              }

              // eslint-disable-next-line @typescript-eslint/no-use-before-define
              _this.throttlefindNearXY(pageX, pageY, fL, fT, $visualContent);
            }
          });

          const $moduleWrapOrGfRow = $gryffEditor.find('.module-wrap, .gf_row');
          $moduleWrapOrGfRow.off('mouseover.drag').on('mouseover.drag', _this.showAvailablePlaceHolder);

          // cancel drag snippet
          if ($targetElement == undefined) {
            $gfLeftSideBar.off('mouseup.dragL').on('mouseup.dragL', function () {
              _this.hideHelper();
              _this.hideVisualFrame();

              if ($gryffEditor.data('gryffeditor').isDragging()) {
                // enable scroll
                $gryffEditor.data('gryffeditor').setDragging(false);

                // remove draghidden
                $gryffEditor.find('.drag-hidden').remove();
              }
              // reset
              $gfLeftSideBar.off('mousemove.dragL');
              $gfLeftSideBar.off('mouseup.dragL');

              $gryffEditor.trigger('drag-deactive');
            });
          }

          $gryffBody.off('mouseup.dragL').on('mouseup.dragL', function () {
            $gfLeftSideBar.off('mousemove.dragL');
            $gfLeftSideBar.off('mouseup.dragL');
            // remove draghidden if not dragging
            if (!$gryffEditor.data('gryffeditor').isDragging()) {
              $gryffEditor.find('.drag-hidden').remove();
            }
          });

          const $visualContent = $gfVisualFrame.children('#visualContent');
          const screenType =
            $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
          if (screenType != 'lg') {
            $body.on('mousemove.dragB', function (eBody) {
              if ($gryffEditor.data('gryffeditor').isDragging()) {
                const pageX = eBody.pageX;
                const pageY = eBody.pageY;

                const fST = $gfFrame.contents().scrollTop();
                _this.updateHelper(pageX, pageY, 0, 0, fST, 1);
                // find nearrest Y
                _this.throttlefindNearXY(pageX, pageY, fL, fT, $visualContent);
              }
            });
          }

          let _counter = 0;
          $gryffBody.off('mousemove.drag').on('mousemove.drag', function (eFour) {
            eFour.preventDefault();

            if ($targetElement != undefined) {
              _counter++;
              if (_counter > 3) {
                $gryffEditor.data('gryffeditor').setDragging(true);
              } else {
                $gryffEditor.data('gryffeditor').setDragging(false);
              }
            }

            if (optimizeInitDragHidden) {
              _this.initDragHidden();
            }

            if ($gryffEditor.data('gryffeditor').isDragging()) {
              /// DRAGGING =========================================
              _this.settings.drag();
              const pageX = eFour.pageX || 0;
              const pageY = eFour.pageY || 0;

              _this.updateHelper(pageX, pageY, fL, fT, 0, window._zoomOut);

              if ($targetElement != undefined && !window._isDetached) {
                $stElement = $targetElement.detach();
                _this.showDragHidden();

                $gryffEditor.trigger('drag-active');
                window._isDetached = true;

                // Hide tools
                if ($stElement.data('gfrow') != undefined) {
                  $stElement.data('gfrow').hideTool();
                } else if ($stElement.data('gfmodule') != undefined) {
                  $stElement.data('gfmodule').hideTool();
                } else if ($stElement.data('gfelement') != undefined) {
                  $stElement.data('gfelement').hideTool();
                }
              }

              _this.throttlefindNearXY(pageX, pageY, fL, fT, $visualContent);

              // SCROLL PAGE TOP - BOTTOM
              const fST = $gfFrame.contents().scrollTop() || 0;
              const calY = pageY * window._zoomOut - fST * window._zoomOut;

              let bottom;
              if (window._zoomOut < 1) {
                bottom = ($gfFrame.height() || 0) * window._zoomOut - 80;
              } else {
                bottom = ($gfFrame.height() || 0) * window._zoomOut - 80;
              }

              if (calY < 80) {
                $gfFrame
                  .contents()
                  .find('html')
                  .scrollTop(fST - 20);
                $gfFrame
                  .contents()
                  .find('body')
                  .scrollTop(fST - 20);

                if (
                  ($gfFrame.contents().find('html').scrollTop() || 0) > 0 ||
                  ($gfFrame.contents().find('body').scrollTop() || 0) > 0
                ) {
                  const top = parseInt($gfVisualFrame.css('top')) + 20;
                  $gfVisualFrame.css('top', top);
                } else {
                  $gfVisualFrame.css('top', 0);
                }
              }
              if (calY > bottom) {
                $gfFrame
                  .contents()
                  .find('html')
                  .scrollTop(fST + 20);
                $gfFrame
                  .contents()
                  .find('body')
                  .scrollTop(fST + 20);

                if (
                  fST < ($gfFrame.contents().find('html').scrollTop() || 0) ||
                  fST < ($gfFrame.contents().find('body').scrollTop() || 0)
                ) {
                  const top = parseInt($gfVisualFrame.css('top')) - 20;
                  $gfVisualFrame.css('top', top);
                }
              }
            }

            return false;
          });

          $gryffBody.off('mouseup.drag').on('mouseup.drag', function (eFive) {
            eFive.preventDefault();

            _this.hideHelper();
            _this.hideVisualFrame();

            $moduleWrapOrGfRow.off('mouseover.drag');

            let notDragging = true;

            if ($gryffEditor.data('gryffeditor').isDragging()) {
              // enable scroll
              $gryffEditor.data('gryffeditor').setDragging(false);
              notDragging = false;
            }

            _this.settings.stop(nearY, $from, $to, $stElement, $dragHidden, notDragging);
            if (optimizeInitDragHidden) {
              isInitDragHidden = false;
              $gryffEditor.find('.drag-hidden.show').remove();
            }

            $gryffBody.off('mousemove.drag');
            $gryffBody.off('mouseup.drag');

            $body.off('mousemove.dragB');
            $body.off('mouseup.dragB');

            $gryffEditor.trigger('drag-deactive');
          });

          $body.off('mouseup.dragB').on('mouseup.dragB', function (eFive) {
            eFive.preventDefault();

            _this.hideHelper();
            _this.hideVisualFrame();
            if ($gryffEditor.data('gryffeditor').isDragging()) {
              // enable scroll
              $gryffEditor.data('gryffeditor').setDragging(false);

              /// STOP DRAGGING =========================================
              _this.settings.stop(nearY, $from, $to, $stElement, $dragHidden);
            }
            $gryffBody.off('mousemove.drag');
            $gryffBody.off('mouseup.drag');

            $body.off('mousemove.dragB');
            $body.off('mouseup.dragB');

            $gryffEditor.trigger('drag-deactive');
          });
        }
      }); // end mousedown
    };

    /**
     * Check vị trí hiện tại có được phép kéo thả vào không?
     * @param id id near placeholder
     * @returns bool
     */
    this.passValidatedPlaceholder = function (id: number): boolean {
      // gfPlaceHolders is array placeholder in module to mark the place for gfVSPlaceHolders
      const $placeHolder = window.$gfPlaceHolders.eq(id || 0);
      let isValidated = true;

      // Check visible in carousel
      if ($placeHolder.hasClass('gf_bp--carousel')) {
        const $parentIsOwlItem = $placeHolder.closest('.owl-item');
        if ($parentIsOwlItem && $parentIsOwlItem.length) {
          if (!$parentIsOwlItem.hasClass('active')) {
            isValidated = false;
          }
        }
      }
      return isValidated;
    };

    /**
     * throttlefindNearXY
     * @param pageX ..
     * @param pageY ..
     * @param fL ..
     * @param fT ..
     * @param visualContent
     * @returns ..
     */
    this.throttlefindNearXY = throttle(function (
      pageX: number,
      pageY: number,
      fL: number,
      fT: number,
      visualContent: any,
    ) {
      _this.findNearXY(pageX, pageY, fL, fT, visualContent);
    });

    /**
     * findNearXY
     * @param pageX ..
     * @param pageY ..
     * @returns ..
     */
    this.findNearXY = function (pageX: number, pageY: number) {
      pageX = pageX * window._zoomOut;
      pageY = pageY * window._zoomOut;

      /* findNearXY version 1 */
      if (window._placeHolders && window._placeHolders.length > 0) {
        let top: number;
        let distantY: number;
        let minDistantY = 0;

        nearY = window._placeHolders[0];
        top = (
          nearY || {
            top: 0,
          }
        ).top;
        minDistantY = Math.abs(pageY - top);

        // Find all nearest block-placeholders
        const _selectedX = [];
        const _selectedY = [];

        for (let i = 0; i < window._placeHolders.length; i++) {
          const x1 = (
            window._placeHolders[i] || {
              left: 0,
            }
          ).left;
          const x2 =
            x1 +
            (
              window._placeHolders[i] || {
                width: 0,
              }
            ).width;

          if (pageX >= x1 && pageX <= x2) {
            if (_this.passValidatedPlaceholder(window._placeHolders[i]?.id || 0)) {
              _selectedX.push(window._placeHolders[i]);
            }
          }
        }

        // Find all nearest block-placeholders (by Y)
        for (let i = 0; i < _selectedX.length; i++) {
          top = (
            _selectedX[i] || {
              top: 0,
            }
          ).top;
          distantY = Math.abs(pageY - top);
          if (minDistantY > distantY) {
            minDistantY = distantY;
          }
        }
        for (let i = 0; i < _selectedX.length; i++) {
          top = (
            _selectedX[i] || {
              top: 0,
            }
          ).top;
          distantY = Math.abs(pageY - top);

          if (minDistantY == distantY) {
            _selectedY.push(_selectedX[i]);
          }
        }
        for (let i = 0; i < _selectedY.length; i++) {
          const top = (
            _selectedY[i] || {
              top: 0,
            }
          ).top;
          distantY = pageY - top;

          nearY = _selectedY[i];
          if (distantY <= 0) {
            // take from far to nearest
            break;
          }
        }

        // gfVSPlaceHolders is list placeholder "position: absolute" to show when dragging
        window.$gfVSPlaceHolders.removeClass('active');

        // active "near Y" block-placeholder with YELLOW color

        if (nearY) {
          window.$gfVSPlaceHolders.eq(nearY.id).addClass('active');
        }
      }
      return false;
    };

    /**
     * show all block-placeholders closest to nearY
     * @param event event
     */
    this.showAvailablePlaceHolder = throttle(function (event: Event) {
      if (window.$gfVSPlaceHolders) {
        window.$gfVSPlaceHolders.removeClass('show');
      }

      // Show tool of wrapper
      try {
        if (nearY) {
          const $newPlace = window.$gfPlaceHolders.eq(nearY.id);
          if ($newPlace && $newPlace.length === 1) {
            let $toModule = $newPlace.closest('.module-wrap, .gf_row');
            let $placeholderWrapper = $toModule;
            // Exceptions
            if (
              $toModule.attr('data-label') == 'Product' &&
              $toModule.parent().closest('.module-wrap').attr('data-label') == 'Product List'
            ) {
              $placeholderWrapper = $toModule;
              $toModule = $toModule.closest('[data-label="Product List"]');
            } else if (
              $toModule.attr('data-label') == 'Product' &&
              $toModule.parent().closest('.module-wrap').attr('data-label') == 'Related Products'
            ) {
              $placeholderWrapper = $toModule;
              $toModule = $toModule.closest('[data-label="Related Products"]');
            } else if (
              $toModule.attr('data-label') == 'Article' &&
              $toModule.parent().closest('.module-wrap').attr('data-label') == 'Article List'
            ) {
              $placeholderWrapper = $toModule;
              $toModule = $toModule.closest('[data-label="Article List"]');
            } else if (
              $toModule.hasClass('gf_row') &&
              $toModule.attr('data-label') != 'Row' &&
              $toModule.closest('.module-wrap').attr('data-label') == 'Pricing'
            ) {
              $toModule = $toModule.closest('[data-label="Pricing"]');
            }

            const $toModuleWrapper = $toModule.parents('.gf_row, .module-wrap').add($toModule);

            if ($backupElmShowTool && $backupElmShowTool.length) {
              if ($toModule && $toModule.length > 0) {
                $backupElmShowTool = $backupElmShowTool.not('#' + $toModule.attr('id'));
                if ($toModuleWrapper && $toModuleWrapper.length) {
                  $toModuleWrapper.each(function (_index, el) {
                    $backupElmShowTool = $backupElmShowTool.not('#' + jQuery(el).attr('id'));
                  });
                }
              }
              if ($backupElmShowTool && $backupElmShowTool.length) {
                $backupElmShowTool.each(function (_index, el) {
                  const $el = jQuery(el);
                  if ($el.data('gfelement')) {
                    $el.data('gfelement').hideTool(true);
                  } else if ($el.data('gfrow')) {
                    $el.data('gfrow').hideTool(true);
                  } else if ($el.data('gfmodule')) {
                    $el.data('gfmodule').hideTool(true);
                  }
                });
              }
            }

            if ($toModuleWrapper && $toModuleWrapper.length) {
              $backupElmShowTool = $toModuleWrapper;
              $toModuleWrapper.each(function (_index, el) {
                const $el = jQuery(el);
                if ($el.data('gfrow')) {
                  $el.data('gfrow').showToolAndOutlineForDragdrop();
                } else if ($el.data('gfmodule')) {
                  $el.data('gfmodule').showToolAndOutlineForDragdrop();
                }
              });

              // Show placeholder
              if ($placeholderWrapper && $placeholderWrapper.length) {
                $placeholderWrapper.find('.block-placeholder').each(function (_index, el) {
                  for (let i = 0; i < (window.$gfPlaceHolders as JQuery).length; i++) {
                    if ((window.$gfPlaceHolders as JQuery)[i] == el) {
                      if (_this.passValidatedPlaceholder(i)) {
                        window.$gfVSPlaceHolders.eq(i).addClass('show');
                      }
                      break;
                    }
                  }
                });
              }
            }
          }
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    });

    /**
     * initDragHidden
     * @returns ..
     */
    this.initDragHidden = function () {
      // kiá»ƒm tra náº¿u cÃ³ target lÃ  kÃ©o tháº£ á»Ÿ trong editor
      // $targetElement cÃ³ thá»ƒ lÃ  gfRow, gfModule, gfElement
      if (isInitDragHidden && optimizeInitDragHidden) {
        return;
      }

      if ($targetElement != undefined && !$targetElement.next().hasClass('drag-hidden')) {
        if ($targetElement.hasClass('gf_row-fluid')) {
          $dragHidden = jQuery('<div class="drag-hidden drag-hidden-fluid"></div>');
        } else {
          $dragHidden = jQuery('<div class="drag-hidden"></div>');
        }

        const mW = $targetElement.innerWidth();
        // var mH = $targetElement.innerHeight();
        const mT = $targetElement.css('margin-top');
        const mB = $targetElement.css('margin-bottom');
        const mL = $targetElement.css('margin-left');
        const mR = $targetElement.css('margin-right');

        let dragClass = 'drag-hidden-row';
        switch (_this.settings.type) {
          case 'row':
            dragClass = 'drag-hidden-row';
            break;
          case 'module':
            dragClass = 'drag-hidden-module';
            break;
          case 'element':
            dragClass = 'drag-hidden-element';
            break;
        }

        $dragHidden.addClass(dragClass);
        $dragHidden.css({
          width: mW || 0,
          height: '50px',
          'margin-top': mT || 0,
          'margin-bottom': mB || 0,
          'margin-left': mL || 0,
          'margin-right': mR || 0,
        });

        $dragHidden.insertAfter($targetElement);
        isInitDragHidden = true;
      }
      return false;
    };

    /**
     * showDragHidden
     * @returns boolean
     */
    this.showDragHidden = function () {
      if ($dragHidden != undefined) {
        $dragHidden.addClass('show');
        const $blockPlaceholder = $dragHidden.next('.block-placeholder');
        if ($blockPlaceholder.length > 0) {
          $blockPlaceholder.remove();
        }
      }
      return false;
    };

    /**
     * getDragHelper
     * @param $object ..
     * @returns void
     */
    this.getDragHelper = function ($object: JQuery) {
      // trÆ°á»ng há»£p block thumbnail
      if ($object.children('img.block-thumbnail').length > 0) {
        return $object.children('img.block-thumbnail').clone().css('border', '2px solid #2b87da');
      } else {
        const label = $object.attr('data-label') ? $object.attr('data-label') : 'Unknown';
        const icon = $object.attr('data-icon') ? $object.attr('data-icon') : 'eicon-shortcode';
        let itemClass = '';
        const type = $object.attr('data-type') ? $object.attr('data-type') : 'Unknown';
        switch (type) {
          case 'row':
            itemClass = 'row-item';
            break;
          case 'module':
            itemClass = 'module-item';
            break;
          case 'element':
            itemClass = 'element-item';
            break;
        }
        return '<a href="#" class="item ' + itemClass + '"><i class="' + icon + '"></i> ' + label + '</a>';
      }
    };

    /**
     * initHelper
     * @param pageX ..
     * @param pageY ..
     * @param fL ..
     * @param fT ..
     * @param fST ..
     * @param zoom ..
     * @returns void
     */
    this.initHelper = function (pageX: number, pageY: number, fL: number, fT: number, fST: number, zoom: number) {
      $helper = $gfVisualFrame.children('.gf_content-layouts');
      let htmlHelper;
      if ($targetElement != undefined) {
        htmlHelper = _this.getDragHelper($targetElement);
      } else {
        // Láº¥y helper cá»§a snippet
        htmlHelper = _this.getDragHelper($element);
      }
      $helper.css({
        left: pageX * zoom + fL,
        top: pageY * zoom + fT + fST,
      });

      if ($targetElement == undefined) {
        $helper.addClass('show');
      }
      $helper.html(htmlHelper);

      return false;
    };

    /**
     * updateHelper
     * @param pageX ..
     * @param pageY ..
     * @param fL ..
     * @param fT ..
     * @param fST ..
     * @param zoom ..
     */
    this.updateHelper = function (pageX: number, pageY: number, fL: number, fT: number, fST: number, zoom: number) {
      $helper
        .css({
          left: pageX * zoom + fL,
          top: pageY * zoom + fT + fST,
        })
        .addClass('show');
    };

    /**
     * hideHelper
     */
    this.hideHelper = function () {
      if ($helper != undefined) {
        $helper.removeClass('show');
      }
    };

    /**
     * showVisualFrame
     * @returns ..
     */
    this.showVisualFrame = function () {
      const $gfFrame = jQuery('#gfFrame');
      const $gfVisualFrame = jQuery('#gfVisualFrame');

      if (!$gfVisualFrame.hasClass('show')) {
        // +++ remove class active
        $gfVisualFrame.children('#visualContent').find('.block-placeholder').removeClass('active').removeClass('show');

        const fST = ($gfFrame.contents().scrollTop() || 0) * window._zoomOut;

        $gfVisualFrame
          .css({
            top: -1 * fST,
          })
          .addClass('show');

        // on event scroll
        jQuery($gfFrame.contents()).on('scroll.drag', function (eScroll) {
          eScroll.preventDefault();
          const fST = $gfFrame.contents().scrollTop();
          /* zoomOut trong trÆ°á»ng há»£p editor pháº£i zoomout vÃ¬ khÃ´ng Ä‘á»§ khÃ´ng gian trÃªn mÃ n hÃ¬nh nhá» */
          const top = -1 * (fST || 0) * window._zoomOut;
          $gfVisualFrame.css('top', top);
          return false;
        });

        const vCHeight = $gfFrame.contents().height();
        const vCWidth = ($gfFrame.width() || 0) * window._zoomOut - 5; // trá»« Ä‘i má»™t khoáº£ng 5px Ä‘á»ƒ fix lá»‘i cÄƒn trÃ¡i

        const fL = (
          $gfFrame.offset() || {
            left: 0,
          }
        ).left;
        const sW = parseInt($gfLeftSideBar.find('.side-panels').css('width'));
        const right = Math.abs(fL - sW);

        const $visualContent = $gfVisualFrame.children('#visualContent');
        $visualContent.css('height', vCHeight || 0);
        $visualContent.css('width', vCWidth || 0);
        $visualContent.css('right', right || 0);
      }
      return false;
    };

    /**
     * hideVisualFrame
     * @returns boolean
     */
    this.hideVisualFrame = function () {
      $gfVisualFrame.removeClass('show');

      // off event scroll
      jQuery($gfFrame.contents()).off('scroll.drag');
      return false;
    };

    /**
     * manageStop
     * @param $newPlace ..
     * @param $stElement ..
     * @param $from ..
     * @param $to ..
     * @returns ..
     */
    this.manageStop = function ($newPlace: JQuery, $stElement: JQuery, $from: JQuery, $to: JQuery) {
      $newPlace.after($stElement);
      window._isDetached = false;

      if ($stElement.data('gfmodule') != undefined) {
        // Refresh Carousel
        if ($stElement.attr('data-label') == 'Carousel') {
          $stElement.data('gfmodule').refresh();
        }

        // refresh when change position Before and After Images
        if ($stElement.attr('data-label') == 'Before and After Images') {
          $stElement.data('gfmodule').refresh();
        }

        // refresh when change position Parallax
        if ($stElement.attr('data-label') == 'Parallax') {
          $stElement.data('gfmodule').refresh();
        }
      }

      // $newPlace.remove();
      let html = '';
      let bkHtml = '';
      let htmlOld = '';
      let bkHtmlOld = '';
      let $newElement: JQuery | undefined;

      if (HELPER.isInsideTheList($from) || HELPER.isInsideTheList($to)) {
        let data;
        if ($stElement.data('gfrow') != undefined) {
          data = $stElement.data('gfrow').export('clone');
        } else if ($stElement.data('gfmodule') != undefined) {
          data = $stElement.data('gfmodule').export('clone');
        } else if ($stElement.data('gfelement') != undefined) {
          data = $stElement.data('gfelement').export('clone');
        }

        html = data.html;
        bkHtml = data.bkHtml;

        htmlOld = data.html;
        bkHtmlOld = data.bkHtml;

        const $tmpHtml = jQuery('<div />').html(html);
        const newIdList = [] as any;
        $tmpHtml.find('[data-label][data-id]').each(function () {
          const oldId = jQuery(this).attr('data-id');
          let matchedString;
          if (oldId) {
            matchedString = new RegExp(oldId, 'g');
          }

          const $elm = $gryffBody.find('#' + jQuery(this).attr('id'));

          let newId = '';
          if (HELPER.isInsideTheList($to)) {
            newId = HELPER.MakeIdInsideList($elm, 'new');
            let increase = 1;
            while (jQuery.inArray(newId, newIdList) !== -1) {
              newId = HELPER.MakeIdInsideList($elm, 'new', increase);
              increase++;
            }
          } else {
            newId = HELPER.MakeId() + '';
          }

          newIdList.push(newId);
          if (matchedString) {
            html = html.replace(matchedString, newId);
            bkHtml = bkHtml.replace(matchedString, newId);
          }

          /* for Tabs element / module */
          const regexTab = 'window.getTab(.*)?function';
          if (bkHtml.match(regexTab)) {
            const match = bkHtml.match(regexTab);
            if (match && match[0]) {
              const matchedTab = match[0];
              const matchedStringTab = new RegExp(matchedTab, 'g');

              const newIdSlug = newId.toString().replace(/-/g, '');
              bkHtml = bkHtml.replace(matchedStringTab, 'window.getTab' + newIdSlug + ' = function');
            }
          }
        });
      }

      //1 if content is from outside to inside list
      if (!HELPER.isInsideTheList($from) && HELPER.isInsideTheList($to)) {
        $stElement.after(html);
        HELPER.addContentBk(bkHtml);

        // new child element
        $newElement = $stElement.next();

        if ($newElement.hasClass('gf_row')) {
          // ($newElement as any).gfRow();
          atom.Init($newElement);
        } else if ($newElement.hasClass('module-wrap')) {
          // ($newElement as any).gfModule();
          atom.Init($newElement);
        } else if ($newElement.hasClass('element-wrap')) {
          // ($newElement as any).gfElement();
          atom.Init($newElement);
        }

        $stElement.remove();

        // detect
        HELPER.detectContentChange($from);

        window._contentChangeTimeout = null;

        HELPER.flagListItemChange($newElement, 'new');
        HELPER.detectContentChange($to);

        //2 if content from inside to outside list
      } else if (HELPER.isInsideTheList($from) && !HELPER.isInsideTheList($to)) {
        $stElement.after(html);
        HELPER.addContentBk(bkHtml);

        // new child element
        $newElement = $stElement.next();
        if ($newElement.hasClass('gf_row')) {
          // ($newElement as any).gfRow();
          atom.Init($newElement);
        } else if ($newElement.hasClass('module-wrap')) {
          // ($newElement as any).gfModule();
          atom.Init($newElement);
        } else if ($newElement.hasClass('element-wrap')) {
          // ($newElement as any).gfElement();
          atom.Init($newElement);
        }

        $stElement.detach();
        $stElement.appendTo($from);

        HELPER.flagListItemChange($stElement, 'delete');
        HELPER.detectContentChange($from);

        window._contentChangeTimeout = null;

        HELPER.detectContentChange($to);

        //3 if content from inside to inside list
      } else if (HELPER.isInsideTheList($from) && HELPER.isInsideTheList($to)) {
        $stElement.after(html);
        HELPER.addContentBk(bkHtml);

        // new child element
        $newElement = $stElement.next();
        if ($newElement.hasClass('gf_row')) {
          // ($newElement as any).gfRow();
          atom.Init($newElement);
        } else if ($newElement.hasClass('module-wrap')) {
          // ($newElement as any).gfModule();
          atom.Init($newElement);
        } else if ($newElement.hasClass('element-wrap')) {
          // ($newElement as any).gfElement();
          atom.Init($newElement);
        }

        // move out of a module to product / article
        $stElement.detach();
        $stElement.appendTo($from);

        HELPER.flagListItemChange($stElement, 'delete');
        HELPER.detectContentChange($from);

        if ($from.closest('[data-label]').attr('data-label') != 'Product') {
          window._contentChangeTimeout = null;
          HELPER.detectContentChange($from);
        }

        if ($from.closest('[data-label]').attr('data-label') != 'Article') {
          window._contentChangeTimeout = null;
          HELPER.detectContentChange($from);
        }

        window._contentChangeTimeout = null;

        setTimeout(function () {
          HELPER.flagListItemChange($newElement, 'replace');
          HELPER.detectContentChange($to);
        }, 301);
      } else {
        HELPER.detectContentChange($from);
        if (!$to.is($from)) {
          window._contentChangeTimeout = null;

          HELPER.detectContentChange($to);
        }
      }

      const $toModule = $stElement.closest('.module-wrap');

      const activeElementLabel = $stElement.attr('data-label');
      if (
        activeElementLabel &&
        ['Email Field', 'Text Field', 'Text Area', 'Dropdown', 'Checkbox'].includes(activeElementLabel)
      ) {
        if ($toModule) {
          const toModuleLabel = $toModule.attr('data-label');
          if (toModuleLabel) {
            const elementInputField = $stElement.find('.elm input');
            const elementTextAreaField = $stElement.find('.elm textarea');
            const elementSelectField = $stElement.find('.elm select');

            if (toModuleLabel == 'Product') {
              if (elementInputField.length) {
                const fieldName = elementInputField.attr('name') || '';
                if (fieldName.includes('contact[')) {
                  elementInputField.attr('name', fieldName.replace('contact[', 'properties['));
                } else if (!fieldName.includes('[')) {
                  elementInputField.attr('name', 'properties[' + fieldName + ']');
                }
              }
              if (elementTextAreaField.length) {
                const fieldName = elementTextAreaField.attr('name') || '';
                if (fieldName.includes('contact[')) {
                  elementTextAreaField.attr('name', fieldName.replace('contact[', 'properties['));
                } else if (!fieldName.includes('[')) {
                  elementTextAreaField.attr('name', 'properties[' + fieldName + ']');
                }
              }
              if (elementSelectField.length) {
                const fieldName = elementSelectField.attr('name') || '';
                if (fieldName.includes('contact[')) {
                  elementSelectField.attr('name', fieldName.replace('contact[', 'properties['));
                } else if (!fieldName.includes('[')) {
                  elementSelectField.attr('name', 'properties[' + fieldName + ']');
                }
              }
            } else if (toModuleLabel == 'Contact Form') {
              if (elementInputField.length) {
                const fieldName = elementInputField.attr('name') || '';
                if (fieldName.includes('properties[')) {
                  elementInputField.attr('name', fieldName.replace('properties[', 'contact['));
                } else if (!fieldName.includes('[')) {
                  elementInputField.attr('name', 'contact[' + fieldName + ']');
                }
              }
              if (elementTextAreaField.length) {
                const fieldName = elementTextAreaField.attr('name') || '';
                if (fieldName.includes('properties[')) {
                  elementTextAreaField.attr('name', fieldName.replace('properties[', 'contact['));
                } else if (!fieldName.includes('[')) {
                  elementTextAreaField.attr('name', 'contact[' + fieldName + ']');
                }
              }
              if (elementSelectField.length) {
                const fieldName = elementSelectField.attr('name') || '';
                if (fieldName.includes('properties[')) {
                  elementSelectField.attr('name', fieldName.replace('properties[', 'contact['));
                } else if (!fieldName.includes('[')) {
                  elementSelectField.attr('name', 'contact[' + fieldName + ']');
                }
              }
            } else if (toModuleLabel == 'Newsletter') {
              if (elementInputField.length) {
                const fieldName = elementInputField.attr('name') || '';
                if (fieldName.includes('properties[')) {
                  elementInputField.attr('name', fieldName.replace('properties[', 'customer['));
                } else if (!fieldName.includes('[')) {
                  elementInputField.attr('name', 'customer[' + fieldName + ']');
                }
              }
              if (elementTextAreaField.length) {
                const fieldName = elementTextAreaField.attr('name') || '';
                if (fieldName.includes('properties[')) {
                  elementTextAreaField.attr('name', fieldName.replace('properties[', 'customer['));
                } else if (!fieldName.includes('[')) {
                  elementTextAreaField.attr('name', 'customer[' + fieldName + ']');
                }
              }
              if (elementSelectField.length) {
                const fieldName = elementSelectField.attr('name') || '';
                if (fieldName.includes('properties[')) {
                  elementSelectField.attr('name', fieldName.replace('properties[', 'customer['));
                } else if (!fieldName.includes('[')) {
                  elementSelectField.attr('name', 'customer[' + fieldName + ']');
                }
              }
            }

            if ($stElement.data('gfelement') != undefined) {
              $stElement.data('gfelement').openElementSettings(undefined, undefined, true);
            }
          }
        }
      }

      if (activeElementLabel && ['Video Bg', 'Video Popup'].includes(activeElementLabel)) {
        $stElement.find('video').trigger('play');
      }

      // Update id to module
      if (HELPER.isInsideTheList($from) || HELPER.isInsideTheList($to)) {
        const capture = true;
        if ($newElement) {
          if ($newElement.data('gfelement') != undefined) {
            $newElement.data('gfelement').openElementSettings(undefined, undefined, capture);
          } else if ($newElement.data('gfmodule') != undefined) {
            $newElement.data('gfmodule').openModuleSettings(undefined, undefined, capture);
          } else if ($newElement.data('gfrow') != undefined) {
            $newElement.data('gfrow').openRowSettings(undefined, undefined, capture);
          }
        }
      }

      if ($newElement && $newElement.length > 0) {
        HELPER.generatePlaceholderForm($newElement);
      } else {
        HELPER.generatePlaceholderForm($stElement);
      }

      const $itemContent = $to;
      setTimeout(function () {
        // Kiểm tra xem có paste vào column không.
        let $currentTargetElement;
        let position = {};
        if (HELPER.isInsideTheList($from) || HELPER.isInsideTheList($to)) {
          $currentTargetElement = $newElement;
        } else {
          $currentTargetElement = $stElement;
        }
        if ($gryffEditor.data('gfhistory')) {
          position = $gryffEditor.data('gfhistory').getPosition($itemContent, $currentTargetElement);
        }

        const history = $gryffEditor.data('gfhistory').getLastHistory();
        if (!jQuery.isEmptyObject(history) && history.events && history.events.length > 0) {
          const newEvent = {
            action: 'paste',
            position: position,
            newId: '',
            data: {
              html: '',
              bkHtml: '',
            },
          };

          if (HELPER.isInsideTheList($from) || HELPER.isInsideTheList($to)) {
            if ($newElement) {
              newEvent.newId = $newElement.attr('id') || '';
            }
            newEvent.data.html = htmlOld;
            newEvent.data.bkHtml = bkHtmlOld;
          }
          if (JSON.stringify(history.events[0].position) != JSON.stringify(newEvent.position)) {
            history.events.push(newEvent);

            $gryffEditor.data('gfhistory').removeLastHistory();
            $gryffEditor.trigger('history', history);
          } else {
            $gryffEditor.data('gfhistory').removeLastHistory();
          }
        }
      }, 300);

      // trong truong hop khong the after thi undo
      // setTimeout(function() {
      if ($stElement && $gryffBody.find('#' + $stElement.attr('id')).length == 0) {
        let data = {} as any;
        if ($stElement.data('gfrow') != undefined) {
          data = $stElement.data('gfrow').export('clone');
        } else if ($stElement.data('gfmodule') != undefined) {
          data = $stElement.data('gfmodule').export('clone');
        } else if ($stElement.data('gfelement') != undefined) {
          data = $stElement.data('gfelement').export('clone');
        }
        if (!jQuery.isEmptyObject(data)) {
          // var $itemContent;
          let position = {
            inside: '',
            after: '',
            index: 1,
            key: 'content',
          };

          // Tìm vị trí gần nhất.
          const $div = jQuery('<div id="new-place-' + Date.now() + '"></div>');
          if ($newPlace.length > 0) {
            $newPlace.after($div);
            if ($gryffEditor.data('gfhistory')) {
              position = $gryffEditor.data('gfhistory').getPosition($itemContent, $div);
            }
          } else if ($newPlace.prev().length > 0) {
            $newPlace.prev().after($div);
            if ($gryffEditor.data('gfhistory')) {
              position = $gryffEditor.data('gfhistory').getPosition($itemContent, $div);
            }
          } else if ($newPlace.next().length > 0) {
            $newPlace.next().after($div);
            if ($gryffEditor.data('gfhistory')) {
              position = $gryffEditor.data('gfhistory').getPosition($itemContent, $div);
            }
          } else if ($from.length > 0) {
            $from.after($div);
            if ($gryffEditor.data('gfhistory')) {
              position = $gryffEditor.data('gfhistory').getPosition($itemContent, $div);
            }
          } else {
            let $product: JQuery;
            let $article: JQuery;
            switch ($stElement.attr('name')) {
              case '(P) Title':
              case '(P) Description':
              case '(P) Price':
              case '(P) Cart Button':
              case '(P) Image':
              case '(P) Image List':
              case '(P) Quantity':
              case '(P) Variants':
              case '(P) Swatches':
              case '(P) Meta':
                $product = $gryffBody.find('[data-label="Product"]').eq(0);
                $product.find('.item-content').each(function () {
                  const $itemContent = jQuery(this);
                  if ($itemContent.closest('.module-wrap').is($product)) {
                    $product.find('.item-content').prepend($div);
                  }
                });
                break;
              case '(A) Title':
              case '(A) Image':
              case '(A) Content':
              case '(A) Excerpt':
              case '(A) Date':
                $article = $gryffBody.find('[data-label="Article"]').eq(0);
                $article.find('.item-content').each(function () {
                  const $itemContent = jQuery(this);
                  if ($itemContent.closest('.module-wrap').is($article)) {
                    $article.find('.item-content').prepend($div);
                  }
                });
                break;
            }
            if ($gryffEditor.data('gfhistory')) {
              position = $gryffEditor.data('gfhistory').getPosition($itemContent, $div);
            }
          }
          $div.remove();

          const history = {
            id: $stElement.attr('id'),
            action: 'delete',
            position: position,
            data: {
              html: data.html,
              bkHtml: data.bkHtml,
            },
          };
          $gryffEditor.trigger('history', history);

          // remove draghidden
          $gryffEditor.find('.drag-hidden').remove();
        }
      }
      // }, 300);
      return false;
    };

    this.init();
  };

  /**
   * gfDraggable
   * @param options ..
   * @returns ..
   */
  (jQuery.fn as any).gfDraggable = function (options: object) {
    return (this as JQuery).each(function () {
      if (undefined == jQuery(this).data('gfdraggable')) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const plugin = new (jQuery as any).gfDraggable(this, options);
        jQuery(this).data('gfdraggable', plugin);
      }
    });
  };
})(jQuery);
